export const MRT_CONTEXT_BASEPATH = '/mobify/mrt'
export const MRT_API_BASEPATH = MRT_CONTEXT_BASEPATH + '/api'
export const MAX_CACHE_AGE = 60 * 15 // 15 min
export const MAX_CACHE_AGE_SEARCH = 60 * 3 // 3 min

export const QUERY_PARAMS_EXCLUSIONS = [
    '_gl',
    'ad_id',
    'adfcd',
    'awc',
    'brid',
    'c_id',
    'campaign_id',
    'changeCountry',
    'clickId',
    'cluid',
    'cto_pld',
    'dclid',
    'dctx',
    'et_rid',
    'fbclid',
    'gad',
    'gad_campaignid',
    'gad_source',
    'gbraid',
    'gclid',
    'gclsrc',
    'gtm_latency',
    'hgtid',
    'j',
    'jb',
    'l',
    'mid',
    'mp-ble-nbc',
    'msclkid',
    'pageName',
    'sa',
    'sfmc_activityid',
    'sfmc_id',
    'sfmc_sub',
    'sfnsn',
    'source',
    'srsltid',
    'sv1',
    'sv_campaign_id',
    'tduid',
    'trlid',
    'ttclid',
    'u',
    'usg',
    'ust',
    'utm-content',
    'utm_campaign',
    'utm_content',
    'utm_id',
    'utm_medium',
    'utm_parameters',
    'utm_source',
    'utm_term',
    'wbraid',
    'DA',
    'TabSegment',
    'UniqueId',
    'Url',
    '_ly_c',
    '_ly_r',
    '_ly_src',
    '_sm_b',
    'aCtx',
    'ackey',
    'acq',
    'acr',
    'adurl',
    'afr',
    'ai',
    'ala_anti',
    'amp_gsa',
    'amp_js_v',
    'amplitudeClickId',
    'app',
    'ase',
    'asres',
    'awinaffid',
    'awinmid',
    'baiduid',
    'bannerparamv1',
    'bd_page_type',
    'bdenc',
    'bdver',
    'bnrh',
    'bnrw',
    'bsc',
    'bvstate',
    'category',
    'category_id',
    'catid',
    'cbta',
    'cbtt',
    'cce',
    'ceneo_cid',
    'cfclick',
    'cid',
    'ck0',
    'ck1',
    'ck2',
    'ck3',
    'ck6',
    'ck7',
    'ckx',
    'cky',
    'clickarea',
    'clickref',
    'clickref2',
    'clickref3',
    'clickref4',
    'clientClickId',
    'clientTime',
    'clk_info',
    'clk_type',
    'cltj',
    'cmpid',
    'co',
    'cpb',
    'cpp',
    'cppv',
    'ctime',
    'ctorigin',
    'ctype',
    'cuid',
    'cv',
    'cz',
    'di',
    'dict',
    'domain',
    'dp',
    'ei',
    'entryContent',
    'entryScene',
    'entryTime',
    'epi',
    'epi2',
    'epslanguage',
    'eqid',
    'extra',
    'fbm',
    'fm',
    'from',
    'fromapp',
    'fromapp_co',
    'fzmode',
    'gallery',
    'gs_lcrp',
    'gs_lp',
    'history',
    'hl',
    'htindex',
    'htpos',
    'htprequery',
    'htsourceid',
    'ie',
    'iflsig',
    'ignorenitro',
    'ii',
    'import_history',
    'import_history_from',
    'inpage',
    'isAtom',
    'is_baidu',
    'it',
    'js',
    'jump_from',
    'keyword',
    'lastuuid',
    'ldtag_cl',
    'lead',
    'li',
    'lid',
    'lkapi',
    'lsfr',
    'lt_r',
    'lti',
    'maxdest',
    'mcpErrorActionTrigger',
    'nTp',
    'nb',
    'nil_profile',
    'nis',
    'noticeType',
    'nsrc',
    'nt',
    'num',
    'nzq',
    'oPsn',
    'option',
    'oq',
    'oquery',
    'order',
    'otn',
    'outputType',
    'pagetype',
    'paralProfileId',
    'phoneos',
    'pi',
    'pidx',
    'platform',
    'ppC',
    'ppI',
    'ppS',
    'ppU',
    'ppb',
    'pr',
    'productId',
    'provider',
    'pt',
    'pu',
    'pwrt',
    'qb_c_bid',
    'qdt',
    'qs',
    'query',
    'rcer',
    'rchannel',
    'rct',
    'rdt',
    'recid',
    'redir',
    'ref',
    'refpage',
    'rfrom',
    'ri',
    'rlz',
    'route',
    'rqid',
    's_from',
    'sca_esv',
    'scenario_ID',
    'sclient',
    'sd',
    'search',
    'sec',
    'sf',
    'sig',
    'sise',
    'sm',
    'sourceid',
    'sq',
    'sqi',
    'srclt',
    'ssc',
    'ssid',
    'st',
    'sticky',
    'sugo',
    'sv_affiliate_id',
    'sv_tax1',
    'sv_tax2',
    'sv_tax3',
    'sv_tax4',
    'tToken',
    'tcplug',
    'text',
    'ticket',
    'title',
    'tj',
    'tqi',
    'trackingCode',
    'trackingLink',
    'uact',
    'ued',
    'ui',
    'usqp',
    'ved',
    'vi',
    'view',
    'vit',
    'vwt',
    'w_qd',
    'waplogo',
    'wd',
    'where',
    'yk_tag',
    'zccpm',
]
